import React from 'react';
import './Hero.css';
import heroImage from '../assets/hero-image-v2.png'; // Bu resmi assets klasörüne ekleyin

const Hero = () => {
  return (
    <section className="hero">
      <div className="container hero-container">
        <div className="hero-content" data-aos="fade-right">
          <h1 className="hero-title">
            Master the <span className="gradient-text">Crypto Market</span>
          </h1>
          <p className="hero-description">
            Kripto piyasaları takip edin ve yapay zeka destekli uzman analizlerle daha bilinçli kararlar verin.
          </p>
          <div className="hero-buttons">
            <a href="#download" className="btn">Şimdi İndir</a>
            <a href="#features" className="btn btn-outline">Daha Fazla Bilgi</a>
          </div>
        </div>
        <div className="hero-image" data-aos="fade-left" data-aos-delay="200">
          <img src={heroImage} alt="CTO App" />
        </div>
      </div>
      <div className="hero-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
    </section>
  );
};

export default Hero; 